<h2 mat-dialog-title class="font-medium">
  <fa-icon class="flex-shrink-0 mr-2" [icon]="['fas', 'warning']"></fa-icon>
  {{ data.title }}</h2>

<mat-dialog-content class="p-4">
    
        <div class="mb-4 leading-6">
          <p>{{ data.message }}</p>
        </div>
    
        <div mat-dialog-actions class="flex justify-between">
          <button mat-button (click)="onDismiss()">Cancel</button>
          <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Confirm</button>
        </div>
    
    </mat-dialog-content>